import subDays from 'date-fns/subDays';
import { formatDate } from 'helpers/date';

export enum ECustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email'
  // DOCUMENT = 'document_number'
}

export const CustomerTypes = [
  // { label: 'CPF/CNPJ', value: ECustomerSearchTypes.DOCUMENT },
  { label: 'Email', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME }
];

export const initialFilterValues: IFilter = {
  customer: '',
  date: [formatDate(subDays(new Date(), 7), 'dd/MM/yyyy'), formatDate(new Date(), 'dd/MM/yyyy')],
  customer_type: ECustomerSearchTypes.NAME,
  product_id: []
};

export interface IProducerRatingService {
  rated_at: string;
  rated_at_final: string;
  rater_name?: string;
  rater_email?: string;
  rater_document?: string;
}

export interface IProductRatingService {
  rated_at: string;
  rated_at_final: string;
  rater_name?: string;
  rater_email?: string;
  rater_document?: string;
  product_id?: number[];
}

export interface IFilter {
  customer?: string;
  customer_type?: ECustomerSearchTypes;
  date: string[];
  product_id?: [];
}

export interface IProducerRating {
  payload_id: string;
  rater_id: string;
  rater: string;
  rated_at: string;
  rating: string;
  comment: string;
  moderated: boolean;
}

export interface IProductRating {
  id: number;
  product_id: number;
  product_title: string;
  rater: string;
  rated_at: string;
  rate: string;
  comment: string;
  moderated: boolean;
  visible: boolean;
}
